import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React from "react";

export interface Ioption {
  label: string | number;
  value: number;
  disabled?: boolean;
}

interface Props {
  options: Ioption[];
  handleChange: (value: any, key: string) => void;
  value?: number;
  selectFor: string;
}

export default function CustomSelectOption({
  options,
  handleChange,
  value,
  selectFor,
}: Props) {
  const onChange = (event: SelectChangeEvent) => {
    handleChange(event.target.value, selectFor);
  };

  return (
    <Select
      placeholder="بخش مربوطه را انتخاب کنید"
      sx={{
        "& .MuiSelect-select": {
          paddingX: "16px !important",
        },
        "& .MuiSvgIcon-root": {
          position: "static !important",
          left: "16px",
          marginLeft: "10px",
          // height: "48px !important",
        },
        width: "100%",
        height: "48px",
        overflow: "auto",
      }}
      size="small"
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={value?.toString()}
      // label="Age"
      onChange={onChange}
    >
      {options.map((item) => (
        <MenuItem disabled={item.disabled} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}
